import { MessageBox, Message } from "element-ui";
import { claimWaitingStudentApi } from "@/api/studentManage";
export function waitingStudentClaimConfirm(params) {
  /*
  params.studentName
  params.studentID
  params.claimFailCallback 认领失败回调
  params.claimSuccessCallback 认领成功回调
  params.claimRefuseCallback 手动取消认领回调
  */
  MessageBox.confirm(
    `确认对${params.studentName}学员认领吗？认领后，归属为您的意向学员，负责学员跟进，可操作学员业务`,
    `确认认领`,
    {
      confirmButtonText: "确定",
      confirmButtonClass: "mwow-button-filled success mini",
      cancelButtonText: "取消",
      cancelButtonClass: "mwow-button-filled mini",
      iconClass: "mwow-icon-error",
    }
  )
    .then(() => {
      claimWaitingStudentApi({
        student_ids: [params.studentID],
      }).then((res) => {
        if (res.data.fail_total > 0) {
          Message({
            type: "error",
            message: res.data.fail_message,
          });
          if (params.claimFailCallback) {
            params.claimFailCallback();
          }
        } else {
          Message({
            type: "success",
            message: "认领成功",
          });
          if (params.claimSuccessCallback) {
            params.claimSuccessCallback();
          }
        }
      });
    })
    .catch(() => {
      if (params.claimRefuseCallback) {
        params.claimRefuseCallback();
      }
    });
}
